import { render, staticRenderFns } from "./SdsList.vue?vue&type=template&id=b0230f9a&scoped=true&"
import script from "./SdsList.vue?vue&type=script&lang=js&"
export * from "./SdsList.vue?vue&type=script&lang=js&"
import style0 from "./SdsList.vue?vue&type=style&index=0&id=b0230f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0230f9a",
  null
  
)

export default component.exports